import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MultiBusinessLineData {
  businessLines: { businessLineId: number; businessLineName: string }[];
  orderName?: string;
}

@Component({
  selector: 'unicon-multi-business-line-dialog',
  templateUrl: './multi-business-line-dialog.component.html',
  styleUrls: ['./multi-business-line-dialog.component.scss'],
  standalone: false,
})
export class MultiBusinessLineDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MultiBusinessLineData,
    public dialogRef: MatDialogRef<MultiBusinessLineDialogComponent>,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onContinue(): void {
    this.dialogRef.close(true);
  }
}
